import axios from '@axios'

const route = 'account'

export default {
  namespaced: true,
  state: {
    account: {
      id: null,
      name: '',
      email: '',
      role: '',
      status: '',
      company: '',
      birthday: '',
      country: '',
      phone: '',
      state: '',
      city: '',
      linguage: '',
    },
    loadingPhoto: false,
    photo: null,
    errors: {},
  },
  getters: {
    getAccount: state => state.account,
    getErrors: state => state.errors,
    getPhoto: state => state.photo,
    getLoadingPhoto: state => state.loadingPhoto,
  },
  mutations: {
    setAccount(state, account) {
      state.account = account
    },
    setErrors(state, errors) {
      state.errors = errors
    },
    setPhoto(state, photo) {
      state.photo = photo
    },
    setLoadingPhoto(state, loading) {
      state.loadingPhoto = loading
    },
  },
  actions: {
    loadAccount() {
      return axios.get(`${route}/index`)
    },
    saveAccount(context) {
      return axios.put(`${route}/update`, context.state.account)
    },
    savePhoto(context, data) {
      const formData = new FormData()
      formData.append('photo', context.getters.getPhoto)

      return axios.post(`${route}/photo`, formData)
    },
    deletePhoto(context) {
      return axios.delete(`${route}/remove_photo`)
    },
    changePassword(context, data) {
      return axios.post(`${route}/change_password`, data)
    },
  },
}
